import {
  getPayCallbackService,
  OrderInfo,
  PayResult,
  PayStatus,
  PayType,
  requestPayService,
} from "@/services/order";
import { message, Modal, QRCode, Row, Spin } from "antd";
import { ReactComponent as WeixinPayIcon } from "@/assets/images/wechat_pay.svg";
import { useRequest } from "ahooks";
import { ResponseCode } from "@/constants";
import { CheckCircleFilled } from "@ant-design/icons";
import { useEffect } from "react";
import useToken from "antd/es/theme/useToken";

export default function WeChatPay(props: {
  open: boolean;
  onClose: () => void;
  orderInfo?: OrderInfo;
  onSuccess: () => void;
}) {
  const [, token] = useToken();
  const { open, onClose, orderInfo, onSuccess } = props;

  const { data: requestPayInfo, loading } = useRequest(
    async () => {
      const rsp = await requestPayService({
        orderId: orderInfo?.orderId || "",
        payType: PayType.WECHAT,
      });
      if (rsp.code !== ResponseCode.Success) {
        message.error(rsp.msg);
      }
      fetchStatus(rsp.data);
      return rsp.data;
    },
    { ready: open && !!orderInfo, refreshDeps: [open] }
  );

  const {
    data: status = PayStatus.WAIT,
    cancel,
    run: fetchStatus,
  } = useRequest(
    async (requestPayInfo: PayResult) => {
      if (status === PayStatus.DONE || status === PayStatus.CANCEL) {
        setTimeout(() => {
          onSuccess();
        }, 1000);
        cancel();
      }
      const rsp = await getPayCallbackService({
        payId: requestPayInfo?.payId || "",
      });
      if (rsp.code !== ResponseCode.Success) {
        message.error(rsp.msg);
        return;
      }
      return rsp.data;
    },
    {
      pollingInterval: 1000,
      manual: true,
    }
  );

  useEffect(() => {
    if (!open) {
      cancel();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="微信支付"
      footer={null}
      width={480}
    >
      <div className="text-center mb-1">
        <div>支付金额:</div>
        <div>
          <span className="text-base text-[#EC7057]">¥</span>
          <span className="text-[32px] font-[DIN] text-[#EC7057]">
            {orderInfo?.amount}
          </span>

          <QRCode
            value={requestPayInfo?.codeUrl || "loading"}
            size={166}
            className="mt-[28px] mb-[14px] mx-auto"
            bordered={false}
            status={
              loading
                ? "loading"
                : status === PayStatus.WAIT || status === PayStatus.PAYING
                ? "active"
                : (status as any)
            }
            statusRender={(info) => {
              switch (info.status as string) {
                case PayStatus.DONE:
                  return (
                    <div className="text-xxl">
                      <CheckCircleFilled
                        style={{ color: token.colorPrimary }}
                        size={32}
                        className="mr-2"
                      />
                      支付成功
                    </div>
                  );
                case "loading":
                  return <Spin />;
                case PayStatus.CANCEL:
                  return (
                    <div>
                      <div>支付取消</div>
                      <a>重新获取二维码</a>
                    </div>
                  );
                default:
                  return null;
              }
            }}
          />

          <Row
            justify="center"
            className="text-primary mb-[45px]"
            align="middle"
          >
            <WeixinPayIcon className="mr-2" />
            微信支付
          </Row>
        </div>
      </div>
    </Modal>
  );
}
